import type {RecordEditation} from 'src/typings';
import type {RecordEditationAction} from '../types';

// wrapper export class containing action and corresponding response from server
export class ActionAndResponse {
    constructor(public action: RecordEditationAction, public response: RecordEditation) {
    }
}